import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './PortfolioSection.css';

function PortfolioSection() {

  const [ref1, inView1] = useInView({
    threshold: 0.5,
  });

  const [ref2, inView2] = useInView({
    threshold: 0.5,
  });

  const [ref3, inView3] = useInView({
    threshold: 0.5,
  });

  const [ref4, inView4] = useInView({
    threshold: 0.5,
  });

  const [ref5, inView5] = useInView({
    threshold: 0.5,
  });

  const [ref6, inView6] = useInView({
    threshold: 0.5,
  });


  
  return (
    <section id="portfolio" className="portfolio-section">
      <Container>
        <h2 className="portfolio-title text-center">Portfolio</h2>
        <Row>
        <Col md={4} className="mb-4">

    <motion.div ref={ref1} initial={{ opacity: 0 }} animate={{ opacity: inView1 ? 1 : 0 }} transition={{ duration: 1 }}>
      <Card className="portfolio-card" >
        <Card.Img className="portfolio-img" variant="top" src="images/proyecto1.png" />
        <div className="portfolio-overlay">
          <div className="portfolio-text">
            <Card.Title>Flag Challenge</Card.Title>
            <Card.Text>¡Juega y supera a otros jugadores!</Card.Text>
            <a href="https://flag-challenge-app.netlify.app" target="_blank" rel="noopener noreferrer">
            <Button variant="primary">Ver Demo</Button>
            </a>
          </div>
        </div>
      </Card>
    </motion.div>
 
</Col>
<Col md={4} className="mb-4">

    <motion.div ref={ref2} initial={{ opacity: 0 }} animate={{ opacity: inView2 ? 1 : 0 }} transition={{ duration: 1 }}>
      <Card className="portfolio-card">
        <Card.Img className="portfolio-img" variant="top" src="images/proyecto2.png" />
        <div className="portfolio-overlay">
          <div className="portfolio-text">
            <Card.Title>To Do List</Card.Title>
            <Card.Text>Agendá y recibirás un recordatorio.</Card.Text>
            <a href="https://todolist-pjwm.onrender.com/" target="_blank" rel="noopener noreferrer">
            <Button variant="primary">Ver Demo</Button>
            </a>
          </div>
        </div>
      </Card>
    </motion.div>

</Col>
<Col md={4} className="mb-4">

    <motion.div ref={ref3} initial={{ opacity: 0 }} animate={{ opacity: inView3 ? 1 : 0 }} transition={{ duration: 1 }}>
      <Card className="portfolio-card">
        <Card.Img className="portfolio-img" variant="top" src="images/proyecto3.png" />
        <div className="portfolio-overlay">
          <div className="portfolio-text">
            <Card.Title>AX Notes</Card.Title>
            <Card.Text>Una App Angular para guardar Notas.</Card.Text>
            <a href="https://ax-notes-app.netlify.app/" target="_blank" rel="noopener noreferrer">
            <Button variant="primary">Ver Demo</Button>
            </a>
          </div>
        </div>
      </Card>
    </motion.div>

</Col>

        </Row>

        <Row>
        <Col md={4} className="mb-4">

    <motion.div ref={ref4} initial={{ opacity: 0 }} animate={{ opacity: inView4 ? 1 : 0 }} transition={{ duration: 1 }}>
      <Card className="portfolio-card">
        <Card.Img className="portfolio-img" variant="top" src="images/proyecto4.jpg" />
        <div className="portfolio-overlay">
          <div className="portfolio-text">
            <Card.Title>Veterinaria Mi Mascota</Card.Title>
            <Card.Text>Sitio Completo con API propia</Card.Text>
            <a href="http://alexfrancook.pythonanywhere.com/" target="_blank" rel="noopener noreferrer">
            <Button variant="primary">Ver Demo</Button>
            </a>
          </div>
        </div>
      </Card>
    </motion.div>

</Col>
<Col md={4} className="mb-4">

    <motion.div ref={ref5} initial={{ opacity: 0 }} animate={{ opacity: inView5 ? 1 : 0 }} transition={{ duration: 1 }}>
      <Card className="portfolio-card">
        <Card.Img className="portfolio-img" variant="top" src="images/proyecto5.jpg" />
        <div className="portfolio-overlay">
          <div className="portfolio-text">
            <Card.Title>Piano App</Card.Title>
            <Card.Text>Toca el piano y escribe partituras</Card.Text>
            <a href="https://alex-piano-react.netlify.app/" target="_blank" rel="noopener noreferrer">
            <Button variant="primary">Ver Demo</Button>
            </a>
          </div>
        </div>
      </Card>
    </motion.div>

</Col>
<Col md={4} className="mb-4">
  
    <motion.div ref={ref6} initial={{ opacity: 0 }} animate={{ opacity: inView6 ? 1 : 0 }} transition={{ duration: 1 }}>
      <Card className="portfolio-card">
        <Card.Img className="portfolio-img" variant="top" src="images/proyecto6.png" />
        <div className="portfolio-overlay">
          <div className="portfolio-text">
            <Card.Title>Bomberos Voluntarios</Card.Title>
            <Card.Text>Realizado para los bomberos de mi ciudad</Card.Text>
            <a href="https://bomberos-voluntarios-bv.netlify.app/voluntarios" target="_blank" rel="noopener noreferrer">
            <Button variant="primary">Ver Demo</Button>
            </a>
          </div>
        </div>
      </Card>
    </motion.div>

</Col>

        </Row> 
      </Container> 
    </section>
  );
}

export default PortfolioSection;

